const config = {
  baseURL: process.env.REACT_APP_API_URL,
}

export { config }
